import React from "react";
import { Lock } from "lucide-react";

const LockedFeature = ({ 
  title = "Feature Locked",
  message = "Available for TRIBE members.",
  tier = "member" // "member" or "challenger"
}) => {
  const tierMessage = tier === "challenger" 
    ? "Available for TRIBE Challengers." 
    : "Available for TRIBE members.";

  return (
    <div className="absolute inset-0 bg-white/90 backdrop-blur-sm rounded-2xl flex items-center justify-center z-10">
      <div className="text-center p-6 max-w-xs">
        <div className="w-12 h-12 bg-[#E3EBE5] rounded-full flex items-center justify-center mx-auto mb-4">
          <Lock className="w-5 h-5 text-[#0B3D2E]" />
        </div>
        <h3 className="font-brand text-lg text-[#051F17] mb-2">{title}</h3>
        <p className="text-sm text-[#4A5D56]">{tierMessage}</p>
      </div>
    </div>
  );
};

export default LockedFeature;
